import Vue from "vue";
// import store from "@/store"
import draggable from "vuedraggable";
// import Elements from '@/components/form_elements_gramma/Elements'
import Properties from "@/components/form_elements_gramma/properties/Properties";

import FormElementGrammarName from "@/components/form_elements_gramma/FormElementGrammarName";
import FormElementExplanatoryText from "@/components//form_elements_gramma/FormElementExplanatoryText";
import FormElementExampleSentence from "@/components//form_elements_gramma/FormElementExampleSentence";
import FormElementComment from "@/components//form_elements_gramma/FormElementComment";
import FormElementIllustration from "@/components//form_elements_gramma/FormElementIllustration";

import vm from "@/main";

export const FormBuilder = new Vue({
  store: ["forms"],
  components: {
    draggable,
    Properties,
    FormElementGrammarName,
    FormElementExplanatoryText,
    FormElementExampleSentence,
    FormElementComment,
    FormElementIllustration,
  },
  data() {
    return {
      fields: [
        {
          fieldType: "FormElementGrammarName",
          type: "text",
          text: "文法名",
          key: "Title",
          disabled: true,
          require: false,
          id: "",
          value: {},
          alignItems: "center",
          cols: 12,
        },
        {
          fieldType: "FormElementExplanatoryText",
          type: "text",
          text: "解説文",
          key: "ExplanatoryText",
          disabled: true,
          require: false,
          id: "",
          value: {},
          cols: 12,
        },
        {
          fieldType: "FormElementExampleSentence",
          type: "text",
          text: "例文",
          key: "ExampleSentence",
          disabled: true,
          require: false,
          id: "",
          value: {},
          file: null,
          cols: 12,
        },
        {
          fieldType: "FormElementComment",
          type: "text",
          text: "コメント",
          key: "Comment",
          disabled: true,
          require: false,
          id: "",
          value: {},
          cols: 12,
        },
        {
          fieldType: "FormElementIllustration",
          type: "image",
          text: "挿絵データ",
          key: "Illustration",
          disabled: true,
          require: false,
          id: "",
          file: null,
          cols: 12,
        },
      ],
      sortElementOptions: {
        group: {
          name: "formbuilder",
          pull: false,
          put: true,
        },
        sort: true,
      },
      dropElementOptions: {
        group: {
          name: "formbuilder",
          pull: "clone",
          put: false,
        },
        sort: false,
        filter: ".is-disabled",
      },
    };
  },
  methods: {
    deleteElement(index, form) {
      this.$delete(form, index);
      vm.$store.activeFieldGrammar = {};
      vm.$store.activeTabForFieldsGrammar = "elements";
    },

    cloneElement(index, field, form, fieldsDefaultID) {
      var cloned = this._.cloneDeep(field); // clone deep lodash
      cloned.id = `${fieldsDefaultID}`;
      form.splice(index + 1, 0, cloned);
      this.editElementProperties(cloned);
    },

    editElementProperties(field) {
      if (field.type == "image") {
        vm.$store.activeFieldGrammar = field;
        vm.$store.activeTabForFieldsGrammar = "elements";
      } else {
        vm.$store.activeFieldGrammar = field;
        vm.$store.activeTabForFieldsGrammar = "properties";
      }
    },
  },
});
